
<div class="row margin0px">
  <div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 padding0px cl-notification">
    <span *ngIf="__bIsPasswordExpiryNotification">
      {{__sNotificationMessage}}
      Your account password is about to expire.Please click <a class="clickable" (click)="OpenChangePasswordPopUp()">here</a> to change it.
    </span>
  </div>
</div>
